// extracted by mini-css-extract-plugin
module.exports = {"title":"InvestMarketsHero_title__kb6SU","exhangesTitle":"InvestMarketsHero_exhangesTitle__Ug0zg"};